import CheckIcon from '@mui/icons-material/Check';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { styled } from '@mui/material';
import MenuMui, { MenuProps } from '@mui/material/Menu';
import MenuItemMui from '@mui/material/MenuItem';

export const PatientInfo = styled('div')({
  padding: 10,
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  backgroundColor: '#EDEFF2',
  fontSize: 14,
  color: '#3A4149'
});

export const FormContainer = styled('div')({
  color: '#3A4149',
  margin: 15,
  marginBottom: -1
});

export const FormInfo = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  background: '#FFF',
  paddingBottom: 13,
  borderBottom: '1px solid #E9EAEE',
  color: '#1C3D64',
  b: {
    fontWeight: 500
  }
});

export const FormTitle = styled('div')({
  color: '#1C3D64',
  fontSize: 14,
  marginTop: 8,
  marginBottom: 4
});

export const ConsentNeeded = styled('button')({
  marginLeft: 24,
  color: '#E31B0C',
  textDecoration: 'underline',
  cursor: 'pointer',
  border: 'none',
  background: 'none',
  padding: 0,
  fontWeight: 600,
  fontSize: 12,
  '&:focus': {
    outline: 'none'
  }
});

export const ConsentGiven = styled('div')({
  marginLeft: 24,
  fontWeight: 600,
  color: '#008A06',
  padding: 0,
  fontSize: 12,
  textDecoration: 'underline'
});

export const NotSubmitted = styled('div')({
  display: 'inline-block',
  borderRadius: 4,
  color: '#FFF',
  fontSize: 12,
  lineHeight: '19px',
  fontWeight: 500,
  background: '#ADADAD',
  padding: '0px 4px',
  minWidth: 80,
  textAlign: 'center'
});

export const Completed = styled(({ children, ...props }: any) => (
  <div {...props}>
    <CheckIcon />
    {children}
  </div>
))({
  textAlign: 'center',
  minWidth: 80,
  display: 'inline-block',
  whiteSpace: 'nowrap',
  borderRadius: 4,
  color: '#FFF',
  fontSize: 12,
  lineHeight: '19px',
  fontWeight: 500,
  background: '#008A06',
  padding: '0px 4px',
  svg: {
    width: 12,
    height: 12,
    marginRight: 4,
    marginBottom: -2
  }
});

export const CenteredContent = styled('div')({
  textAlign: 'center'
});

export const CheckMark = styled(CheckCircleOutlineIcon)({
  width: 24,
  height: 24,
  padding: 0,
  color: '#008A06'
});

export const Container = styled('div')({
  height: 'calc(100vh - 344px)',
  marginTop: -1,
  overflow: 'auto'
});

export const ButtonsContainer = styled('div')({
  padding: '16px 24px',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 16
});

export const Menu = styled((props: MenuProps) => (
  <MenuMui
    elevation={2}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    transformOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    {...props}
  />
))(() => ({
  '& .MuiPaper-root': {
    marginTop: -8,
    backgroundColor: '#FFF'
  }
}));

export const MenuItem = styled(MenuItemMui)({
  color: '#565F6F',
  '& .MuiSvgIcon-root': {
    marginRight: 8,
    color: '#0675DD'
  }
});

export const Buttons = styled('div')({
  whiteSpace: 'nowrap',
  marginTop: 8,
  button: {
    marginRight: 6,
    marginLeft: 6,
    color: '#0675DD',
    '&:first-child': {
      marginLeft: 0
    },
    '&:last-child': {
      marginRight: 0
    }
  }
});
